const colorMap = {
  'NOT_LISTED_YET': 'rgb(242, 90, 10)',
  'PARTIALLY_LISTED': 'rgb(0, 100, 255)',
  'ALL_LISTED': 'rgb(0, 168, 101)',
}

export const config = {
  rowSelection: true,
  columns: [
    {
      title: '商品',
      dataIndex: 'goodsName',
      width: 850,
      render: 'nameRender'
    },
    {
      title: '关联产品名称',
      dataIndex: 'busProductName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '需求标签',
      dataIndex: 'bizTagName',
      width: 100,
    },
    {
      title: '所属品类',
      dataIndex: 'catName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '品牌',
      dataIndex: 'brandName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '单位',
      dataIndex: 'unitName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '上架状态',
      dataIndex: 'statusName',
      width: 120,
      fixed: 'right',
      render: (text, record) => (<span style={{ backgroundColor: colorMap[record.status], color: '#fff', padding: '4px 6px'}}> { text } </span>)
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 180,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'showNameKey',
      label: '商品名称',
    },
    {
      name: 'bizTagCode',
      label: '需求标签',
      itemType: 'select',
      data: 'bizOpTypeEnum',
      labelKey: 'description',
      key: 'key'
    },
    {
      label: '品牌',
      name: 'brandId',
      itemType: 'custom',
      render: 'brandRender'
    },
    {
      name: 'status',
      label: '商品状态',
      itemType: 'select',
      data: 'goodsStatusEnum',
      labelKey: 'description',
      key: 'key'
    },
  ],
  footer: [
    {
      label: '新增',
      // auth: 'priceButton1',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [
    {
      label: '删除',
      // auth: 'priceButton4',
      disabled: 'batchDeleteDisabled',
      danger: true,
      ghost: true,
      events: ['onClick:onDelete'],
    },
    {
      label: '批量上架',
      // auth: 'priceButton4',
      disabled: 'onUpDisabled',
      danger: true,
      ghost: true,
      events: ['onClick:multipleEnable'],
    },
    {
      label: '批量下架',
      // auth: 'priceButton4',
      disabled: 'onDownDisabled',
      danger: true,
      ghost: true,
      events: ['onClick:multipleDisable'],
    },
  ],
}
